import { CLEAR_SCREEN, UPDATE_SCREEN } from '../actionConstants/screenConstants';

export const updateScreen = ({ screenId }) => ({ type: UPDATE_SCREEN, payload: { screenId } });
export const clearScreen = () => ({ type: CLEAR_SCREEN });
